'use strict';

var fitt = require('fitt'),
urlClass = require('fitt-url'),
paramHash = require('fitt-paramhash'),
utils = require('../core/utils.js'),
settle = require('../core/settle.js');

/**
                                        * Handles dispatching duties for browser usage (client-side)
                                        *
                                        * @param {String} url - The resource to request
                                        * @param {Object} config - The object containing all incoming config parameters
                                        * @returns {Promise}
                                        */
function xhr(url, config) {
	return new Promise(function (resolve, reject) {
		var requestData = config.data,
		requestHeaders = config.headers,
		request = new XMLHttpRequest(),
		loadEvent = 'onreadystatechange',
		xDomain = false,
		/**
                    * [Client-only]
                    * Set the `directUrl` flag to true, to make a request without parsing the url and its params.
                    * Can be used to make a REST API request that accepts duplicate params.
                    * 
                    * Example: http://fan.core.api.qa.espn.go.com/apis/v2/fans/{SWID}/preferences?id=ABC&id=DEF&id=GHI
                    */
		directUrl = config.directUrl,
		oURL = new urlClass(url);

		oURL.params = new paramHash(fitt.mix({}, [oURL.params, config.params]));

		request.open(config.method.toUpperCase(), directUrl ? url : oURL.toString(), true);

		// Set up cancellation
		if (config.canceler) {
			config.canceler.promise.then(function (reason) {
				if (request) {
					request.abort();
					reject(reason);
				}
			});
		}

		// Set the request timeout in MS
		request.timeout = config.timeout;

		// Listen for ready state
		request[loadEvent] = function () {
			if (!request || request.readyState !== 4 && !xDomain) {
				return;
			}

			// The request errored out and we didn't get a response, this will be
			// handled by onerror instead
			// With one exception: request that using file: protocol, most browsers
			// will return status as 0 even though it's a successful request
			if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
				return;
			}

			// Prepare the response
			var responseHeaders,
			responseData,
			response;
			responseHeaders = 'getAllResponseHeaders' in request ? utils.parseHeaders(request.getAllResponseHeaders()) : null;
			responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
			response = {
				data: responseData,
				// IE sends 1223 instead of 204
				status: request.status === 1223 ? 204 : request.status,
				statusText: request.status === 1223 ? 'No Content' : request.statusText,
				headers: responseHeaders,
				config: config,
				request: request,
				url: url };


			settle(resolve, reject, response);

			// Clean up request
			request = null;
		};

		// Handle low level network errors
		request.onerror = function () {
			// Real errors are hidden from us by the browser
			// onerror should only fire if it's a network error
			reject(utils.createError('Network Error', url, config));

			// Clean up request
			request = null;
		};

		// Handle timeout
		request.ontimeout = function () {
			reject(utils.createError('timeout of ' + config.timeout + 'ms exceeded', url, config, 'ECONNABORTED'));

			// Clean up request
			request = null;
		};

		// Add headers to the request
		if ('setRequestHeader' in request) {
			fitt.forEach(requestHeaders, function (val, key) {
				if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
					// Remove Content-Type if data is undefined
					delete requestHeaders[key];
				} else {
					// Otherwise add header to the request
					request.setRequestHeader(key, val);
				}
			});
		}

		// Add withCredentials to request if needed
		if (config.withCredentials) {
			request.withCredentials = true;
		}

		// Add responseType to request if needed
		if (config.responseType) {
			try {
				request.responseType = config.responseType;
			} catch (e) {
				if (request.responseType !== 'json') {
					throw e;
				}
			}
		}

		if (requestData === undefined) {
			requestData = null;
		}

		// Send the request
		request.send(requestData);
	});
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = xhr;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/dispatch/xhr.js
// module id = 606
// module chunks = 0